import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import TuneIcon from '@material-ui/icons/Tune';
import { white, blue300 } from '../theme/colors';
import { FilterWrapper } from '../pages/dashboard/components/FilterWrapper';
import Loader from './Loader';
import moment from 'moment';

/* ─── Backdrop overlay ─────────────────────────────────────── */
const FilterBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(1.5px);
  -webkit-backdrop-filter: blur(1.5px);
  z-index: 1290;
  opacity: ${({ open }) => (open ? '1' : '0')};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  transition: opacity 0.25s ease, visibility 0.25s ease;
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
`;

/* ─── Panel shell ────────────────────────────────────────── */
const FilterListStyle = styled.aside`
  position: fixed;
  z-index: 1300;
  width: 320px;
  max-width: 88vw;
  top: 0;
  right: ${({ open }) => (open ? '0' : '-350px')};
  height: 100vh;
  background: #f8fafc;
  border-left: 1px solid rgba(203, 213, 225, 0.8);
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);
  transition: right 0.32s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.25s ease;
  opacity: ${({ open }) => (open ? '1' : '0')};
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  scroll-behavior: smooth;

  @media (max-width: 768px) {
    top: 0;
    height: 100vh;
    width: 300px;
    max-width: 86vw;
  }
`;


const TitleStyle = styled.div`
   background: rgba(234, 234, 234, 0.4);
   padding:16px 24px;
   opacity:${({ open }) => open ? '1' : '0'};
   transition: opacity 0.2s;
   
`;

const RightIcons = styled.div`
    position: absolute;
    right: 18px;
    top: 16px;
    svg{
        width:20px;
        height:20px;
        cursor: pointer;
    }
`;

// const ContentStyle = styled.div`
//     padding:10px 20px;
//     height: calc(100vh - 140px);
//     overflow-y: auto;
//     position: relative;
// `;

// const FooterStyle = styled.div`
//     display: flex;

//     bottom: 0;
//     position: absolute;
//     top: auto;
//     width: 100%;
//     top: 0;
//     height: 100vh;
//     right: ${({ open }) => (open ? '0' : '-100%')};
//   }
// `;

/* ─── Header ─────────────────────────────────────────────── */
const HeaderStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #ffffff;
  border-bottom: 1px solid rgba(203, 213, 225, 0.7);
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

const IconBox = styled.div`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 9px;
  background: ${blue300};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: ${white};
    font-size: 17px;
  }
`;

const HeaderText = styled.div`
  min-width: 0;
`;

const HeaderTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
`;

const HeaderSubtitle = styled.div`
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 1px;
`;

const CloseButton = styled.button`
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 8px;
  border: 1px solid rgba(203, 213, 225, 0.8);
  background: ${white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.18s ease;

  svg {
    font-size: 16px;
    color: #64748b;
  }

  &:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    svg { color: #ef4444; }
  }
`;

/* ─── Scrollable content ─────────────────────────────────── */
const ContentStyle = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  position: relative;

  &::-webkit-scrollbar { width: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb {
    background: rgba(62, 150, 200, 0.25);
    border-radius: 4px;
  }
`;

/* ─── Footer ─────────────────────────────────────────────── */
const FooterStyle = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 14px;
  background: #ffffff;
  border-top: 1px solid rgba(203, 213, 225, 0.7);
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
`;

const FooterBtn = styled.button`
  flex: 1;
  height: 40px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
  border: none;

  ${({ variant }) => variant === 'clear' ? `
    background: #f1f5f9;
    color: #475569;
    border: 1px solid rgba(203, 213, 225, 0.8);
    &:hover { background: #e2e8f0; color: #1e293b; }
  ` : `
    background: ${blue300};
    color: #fff;
    &:hover { filter: brightness(1.06); }
    &:active { filter: brightness(0.96); }
  `}
`;

/* ─── Component ──────────────────────────────────────────── */
const Filters = ({
    open,
    closeAction = () => {},
    onClearAllAction = () => {},
    onApplyFilterAction = () => {},
    filterList = [],
    showLoading = false,
    additionalFilters
}) => {
    const [selectedDates, setSelectedDates] = useState(null);
    const [dateError, setDateError] = useState("");
    const [filterKey, setFilterKey] = useState("");
    const handleDateChange = (data, filterKey) => {
        if (data?.filterKey) {
            setFilterKey(data.filterKey);
        }
        if (!data || !data?.dateRange) {
            setSelectedDates(null);
            return;
        }

        setSelectedDates(data);
    };

    const handleApplyFilter = () => {
        if (!selectedDates) { onApplyFilterAction({ dateRange: null, filterKey }); return; }

        if (selectedDates?.filterKey == "qc_inbound_date_range" ||
            (selectedDates?.filterKey && selectedDates.filterKey.includes("qc_inbound")) ||
            selectedDates?.filterKey == "invoice_date"
        ) {
            const { from, to } = selectedDates?.dateRange?.dateRange;
            if (from == null && to == null) {
                setDateError(''); onApplyFilterAction({ ...selectedDates, dateRange: null });
            } else if (from == null) {
                setDateError('Please select from date');
            } else if (to == null) {
                setDateError('Please select to date');
            } else {
                if (moment(from).isAfter(moment(to))) {
                    setDateError('From date should not be after to date');
                } else {
                    setDateError(''); onApplyFilterAction(selectedDates);
                }
            }
        } else {
            setDateError(''); onApplyFilterAction(selectedDates);
        }
    };

    useEffect(() => {
        if (!open) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                closeAction();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [open, closeAction]);

    return (
        <React.Fragment>
            <FilterBackdrop open={open} onClick={closeAction} />
            <FilterListStyle open={open} data-filter-drawer="true" data-open={open ? "true" : "false"}>
                <HeaderStyle>
                    <HeaderLeft>
                        <IconBox><TuneIcon /></IconBox>
                        <HeaderText>
                            <HeaderTitle>Filters</HeaderTitle>
                            <HeaderSubtitle>Refine your results</HeaderSubtitle>
                        </HeaderText>
                    </HeaderLeft>
                    <CloseButton
                        onClick={closeAction}
                        data-shortcut="filter-close"
                        title="Close (Esc or Alt + F)"
                        aria-label="Close filters"
                    >
                        <CloseIcon />
                    </CloseButton>
                </HeaderStyle>

                <ContentStyle>
                    {showLoading && (
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            zIndex: 3,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Loader position="absolute" top="calc(50% - 40px)" />
                        </div>
                    )}
                    {filterList.map((props, i) => (
                        <FilterWrapper key={i} width="100%" {...props} dateError={dateError} getSelectedDates={handleDateChange} />
                    ))}
                    {additionalFilters}
                </ContentStyle>

                {!showLoading && (
                    <FooterStyle>
                        <FooterBtn variant="clear" onClick={onClearAllAction}>Clear All</FooterBtn>
                        <FooterBtn variant="apply" onClick={handleApplyFilter}>Apply Filter</FooterBtn>
                    </FooterStyle>
                )}
            </FilterListStyle>
        </React.Fragment>
    );
};

export default Filters;
